import { Theme, ThemeOptions } from '@mui/material';

import { capitalDesignTokens } from '../../capital_design_tokens';

export const getMenuPaperStyle = (theme: Theme) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: capitalDesignTokens.foundations.units.unitHalf,
  boxShadow: '1px 2px 7px 0px rgba(19, 21, 23, 0.10)',
  marginTop: 2
});

export const MuiMenu: ThemeOptions['components']['MuiMenu'] = {
  defaultProps: {},
  styleOverrides: {
    // Styles applied to Paper component within Menu component
    paper: ({ theme }) => ({
      ...getMenuPaperStyle(theme)
    })
  }
};
